import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
    addPlannedNotification,
    addToBePlannedNotification, deletePlannedNotification,
    deleteToBePlannedNotification,
    receiveJson
} from "./mainSlice";
import { RRule } from "rrule";
import moment from "moment";
import { cancelPushNotification, createDateTrigger, schedulePushNotification } from "@/containers/Notify";
import {
    getAllScheduledNotificationsAsync,
    SchedulableNotificationTriggerInput,
    SchedulableTriggerInputTypes
} from "expo-notifications"
import i18n from "i18n-js";
import { Platform } from "react-native";


/* maps rrule freq numbers to strings */
const freqMap = {
    0: RRule.YEARLY,
    1: RRule.MONTHLY,
    2: RRule.WEEKLY,
    3: RRule.DAILY,
    4: RRule.MINUTELY,
    5: RRule.SECONDLY
}

/* rrule weekdays start with index 0, expo push is 1 to 7 with 1=sunday... */
const rruleWeekdayToExpoPushWeekday = {
    0: 2, // Montag
    1: 3, // Dienstag
    2: 4, // Mittwoch
    3: 5, // Donnerstag
    4: 6, // Freitag
    5: 7, // Samstag
    6: 1  // Sonntag
}

/* sets the default horizon check for certain rrule freq */
const DEFAULT_HORIZON = {
    0: moment.duration(1, 'year'),
    1: moment.duration(1, 'month'),
    2: moment.duration(1, 'week'),
    3: moment.duration(1, 'day'),
};


// TODO
// - initial state

export const notificationsListener = createListenerMiddleware();

notificationsListener.startListening({
    actionCreator: receiveJson,
    effect: async (action, api) => {
        return;
        if(Platform.OS === "web"){
            return
        }
        const list = ['SYNC_CONTACTS', 'SYNC_PLAN','GET_CONTACTS_INLINE','GET_WORKFLOWS_INLINE','ACCEPT_REQUEST_INLINE','DECLINE_REQUEST_INLINE','DELETE_REQUEST_INLINE','REQUEST_CONTACT_INLINE','CREATE_CONTACT_INLINE','UPDATE_CONTACT_INLINE','DELETE_CONTACT_INLINE','UPDATE_CHANNEL_INLINE','DELETE_CHANNEL_INLINE','UPDATE_IMAGE_INLINE','SHARE_WORKFLOW_INLINE','GET_PLAN_OTHER','CREATE_PLAN_INLINE','UPDATE_PLAN_INLINE','DELETE_PLAN_INLINE','PROCESS_QRCODE_INLINE','SHARE_PUBLIC_INLINE','DELETE_PUBLIC_INLINE','DELETE_TASKS_INLINE','UNDELETE_TASKS_INLINE','STUDIO_DONATE','STUDIO_UNDONATE','STUDIO_TAKE','STUDIO_COPY_WF','STUDIO_DELETE_WF']
        if(!list.includes(action.payload.usage)) return

        getAllScheduledNotificationsAsync().then(result => {
            console.warn(JSON.stringify(result, null, 2))
        })

        //api.cancelActiveListeners() // cancel currently running instances

        /** @type{Plan[]}*/ const before = api.getOriginalState().planned?.plans ?? []
        /** @type{Plan[]}*/ const after = api.getState().planned?.plans ?? []
        /** @type{PlannedNotification[]}*/ const plannedNotifications = api.getState().plannedNotifications ?? []
        /** @type{PlannedNotification[]}*/ const toBePlannedNotifications = api.getState().notificationsToBePlanned ?? []
        /** @type{Plan[]}*/ let deletedPlans = []
        /** @type{Plan[]}*/ let newPlans = []
        /** @type{Plan[]}*/ let updatedPlans = []

        before.forEach(plan => {
            let obj = after.find(val => val.id === plan.id)
            if (obj){
                const same = obj.createdAt === plan.createdAt && obj.modifiedAt === plan.modifiedAt
                if(!same){
                    updatedPlans.push(obj)
                }
            } else {
                deletedPlans.push(plan)
            }
        })

        after.forEach(plan => {
            let idx = before.findIndex(val => val.id === plan.id)
            if (idx === -1){
                newPlans.push(plan)
            }
        })

        // Notifications
        for (const item of newPlans) {
            await handleNewPlan(item, api)
        }

        for (const item of deletedPlans) {
            const plannedNotification = plannedNotifications.find(plan => plan.id === item.id)
            if(plannedNotification){
               await handleDeletePlan(plannedNotification, api)
            } else {
                const toBePlannedNotification = toBePlannedNotifications.find(plan => plan.id === item.id)
                if (toBePlannedNotification){
                    api.dispatch(deleteToBePlannedNotification(toBePlannedNotification))
                }
            }
        }

        for (const item of updatedPlans){
            const plannedNotification = plannedNotifications.find(plan => plan.id === item.id)
            if(plannedNotification){
               await handleUpdatePlan(plannedNotification, api)
            } else {
                const toBePlannedNotification = toBePlannedNotifications.find(plan => plan.id === item.id)
                if (toBePlannedNotification){
                    api.dispatch(deleteToBePlannedNotification(toBePlannedNotification))
                }
            }
        }

        for (const item of toBePlannedNotifications){
            const alreadyHandled = deletedPlans.find(plan => plan.id === item.id)
                                            || updatedPlans.find(plan => plan.id === item.id)
                                            || newPlans.find(plan => plan.id === item.id)
            if(alreadyHandled){
                continue;
            }

            if (!item || !item.schedule){
                console.warn("Planned hat kein schedule!", item)
                continue
            }
            const rule = new RRule(RRule.parseString(item.schedule))
            const{nextExist, canBeScheduled} = checkHorizon(rule)
            if (nextExist && !canBeScheduled){
                continue;
            }
            if (!nextExist){
                api.dispatch(deleteToBePlannedNotification(item))
                continue;
            }

            const date = moment(rule.options.dtstart).utc().local().subtract(30, 'minutes')
            /** @type{NavigationData} */const navData = {type: "plannerEvent", workflowId: item.workflowId}
            let token = await schedulePushNotification(
                {
                    title: i18n.t('plannerMessage.title'),
                    body:  i18n.t('plannerMessage.body'),
                    data: {nav: navData}
                },
                createTrigger(rule, date.hour(), date.minute())
            )
            api.dispatch(addPlannedNotification({...item, notificationId: token}))
            api.dispatch(deleteToBePlannedNotification(item))
        }
    }
})

/**
 *
 * @param {PlannedNotification} item
 * @param {ListenerEffectAPI} api
 * @returns {Promise<void>}
 */
async function handleUpdatePlan(item, api) {
    await cancelPushNotification(item.notificationId)
    await api.dispatch(deletePlannedNotification(item))

    await handleNewPlan(item, api)
}

/**
 *
 * @param {PlannedNotification} item
 * @param {ListenerEffectAPI} api
 * @returns {Promise<void>}
 */
async function handleDeletePlan(item, api) {
    await cancelPushNotification(item.notificationId)
    await api.dispatch(deletePlannedNotification(item))
}

/**
 *
 * @param {Plan} item
 * @param {ListenerEffectAPI} api
 * @returns {Promise<void>}
 */
async function handleNewPlan(item, api) {
    if(!item || !item.schedule){
        console.warn("Item no schedule", item)
        return
    }
    const rule = new RRule(RRule.parseString(item.schedule))

    const date = moment(rule.options.dtstart).utc().local().subtract(30, 'minutes')

    if(rule.options.count){ // once
        console.log("Push: ", item)
        /** @type{NavigationData} */const navData = {type: "plannerEvent", workflowId: item.workflowId}
        const token = await schedulePushNotification(
            {
                title: i18n.t('plannerMessage.title'),
                body:  i18n.t('plannerMessage.body'),
                data: {nav: navData}
            },
            createDateTrigger(date.toDate())
        )
        await api.dispatch(addPlannedNotification({...item, notificationId: token}))
    }else if(!isNaN(rule.options.freq)){ // recurring

        const{nextExist, canBeScheduled} = checkHorizon(rule)
        if (nextExist && !canBeScheduled){
            await api.dispatch(addToBePlannedNotification(item))
            return
        }
        if (!nextExist){
            return
        }

        console.log("Push: ", item)
        /** @type{NavigationData} */const navData = {type: "plannerEvent", workflowId: item.workflowId}
        let token = await schedulePushNotification(
            {
                title: i18n.t('plannerMessage.title'),
                body:  i18n.t('plannerMessage.body'),
                data: {nav: navData}
            },
            createTrigger(rule, date.hour(), date.minute())
        )

        await api.dispatch(addPlannedNotification({...item, notificationId: token}))
    }
}

/**
 *
 * @param {RRule} rule
 * @returns {{nextExist: boolean, canBeScheduled: boolean}}
 */
function checkHorizon(rule){
    const nowUtc = moment.utc()
    const next = rule.after(nowUtc.toDate(), true)
    if (!next){
        return {nextExist: false, canBeScheduled: false}
    }
    const nextUtc = moment(next).utc()
    console.log(nextUtc)
    if (nextUtc.isSameOrBefore(nowUtc)) {
         return {nextExist: false, canBeScheduled: false}
    }

    const deadline = nowUtc.clone().add(DEFAULT_HORIZON[rule.options.freq])
    console.log(deadline)
    if(nextUtc.isSameOrAfter(deadline)){
        console.log("Too much in the future")
        return  {nextExist: true, canBeScheduled: false}
    }
     return {nextExist: true, canBeScheduled: true}
}

/**
 * creates the trigger for an expo push notification
 * @param {RRule} rule
 * @param {number} hour
 * @param {number} minute
 * @returns {SchedulableNotificationTriggerInput}
 */
function createTrigger(rule, hour, minute){
    const freq = freqMap[rule.options.freq]
    switch (freq) {
        case RRule.YEARLY: {
            const month = rule.options.bymonth[0]-1 // hehe, 1 is not january, do -1 :D
            const monthDay = rule.options.bymonthday[0] // monthDays are indeed normally starting by 1
            return {
                type: SchedulableTriggerInputTypes.YEARLY,
                hour: hour,
                minute: minute,
                day: monthDay,
                month: month
            }
        }
        case RRule.MONTHLY: {
            const monthDay = rule.options.bymonthday[0]
            return {
                type: SchedulableTriggerInputTypes.MONTHLY,
                hour: hour,
                minute: minute,
                day: monthDay,
            }
        }
        case RRule.WEEKLY: {
            const expoDay = rruleWeekdayToExpoPushWeekday[rule.options.byweekday[0]]
            return {
                type: SchedulableTriggerInputTypes.WEEKLY,
                hour: hour,
                minute: minute,
                weekday: expoDay
            }
        }
        case RRule.DAILY: {
            return {
                type: SchedulableTriggerInputTypes.DAILY,
                hour: hour,
                minute: minute,
            }
        }
    }
}
